interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  tone?: "primary" | "accent" | "secondary";
}

const toneMap = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function SectionHeading({ eyebrow, title, desc, tone = "primary" }: SectionHeadingProps) {
  return (
    <div className="max-w-3xl">
      <span
        className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-medium tracking-wide ${toneMap[tone]}`}
      >
        <span className="w-1.5 h-1.5 rounded-full bg-current" aria-hidden="true"></span>
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-3xl md:text-4xl text-foreground-950 leading-tight">{title}</h2>
      {desc && <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>}
    </div>
  );
}